import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { WarningAmber } from '@mui/icons-material';

type UnpublishConfirmationModalProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
};

export const UnpublishConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}: UnpublishConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      aria-labelledby="unpublish-confirmation-dialog-title"
    >
      <DialogTitle id="unpublish-confirmation-dialog-title">
        {t('pages.studies.unpublish.modal.title')}
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            mb: 3,
            display: 'flex',
            justifyContent: 'space-evenly',
            alignItems: 'center',
          }}
        >
          <WarningAmber color="error" sx={{ mr: 2 }} />
          <Typography variant="body1" width={300}>
            {t('pages.studies.unpublish.modal.message')}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={isLoading}
          color="secondary"
        >
          {t('pages.studies.unpublish.modal.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          disabled={isLoading}
          autoFocus
        >
          {t('pages.studies.unpublish.modal.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
